module.exports = __webpack_public_path__ + "img/about4.8d0ead36.png";